import { collabActionTypes } from './collab.types';

export const joinRoom = (diagramId) => ({
    type: collabActionTypes.COLLAB_JOIN_ROOM,
    payload: { diagramId },
});

export const leaveRoom = () => ({
    type: collabActionTypes.COLLAB_LEAVE_ROOM,
});

// Backend doc §4.2 — ack returns { ok, role, members: Uint8Array }.
// `role` is stored in Redux; `members` is binary awareness state and is
// applied directly to the awareness instance via lib/yjs — it does NOT
// enter Redux.
export const roomJoined = ({ diagramId, role }) => ({
    type: collabActionTypes.COLLAB_ROOM_JOINED,
    payload: { diagramId, role },
});

export const roomLeft = () => ({
    type: collabActionTypes.COLLAB_ROOM_LEFT,
});

export const joinFailed = (error) => ({
    type: collabActionTypes.COLLAB_JOIN_FAILED,
    payload: { error },
});

// Backend doc §7.2 — server-pushed event when a frame the client sent
// was rejected. Not fatal; the socket stays connected. The reducer
// stores the latest reason for UI surfacing.
export const docUnauthorized = (reason) => ({
    type: collabActionTypes.COLLAB_DOC_UNAUTHORIZED,
    payload: { reason },
});

export const collabReset = () => ({
    type: collabActionTypes.COLLAB_RESET,
});
